import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SessionHandoffState } from '../state';

export const getSessionHandoffState = createFeatureSelector<SessionHandoffState.State>('sessionHandoff');

export const getAssociatedUsers = createSelector(
  getSessionHandoffState,
  (state: SessionHandoffState.State) => state.associatedUsers
);